{
  "professionOptions": {
    "accountingBankingInsuranceFinance": {
      "title": "Accounting, Banking, Insurance and Finance",
      "titles": {
        "accountant": "Accountant",
        "actuary": "Actuary",
        "auditor": "Auditor",
        "bankAdministrator": "Bank Administrator",
        "bookkeeper": "Bookkeeper",
        "branchManager": "Branch Manager",
        "chiefFinancialOfficer": "Chief Financial Officer",
        "claimsAdjuster": "Claims Adjuster",
        "clericalWorker": "Clerical Worker",
        "commoditiesTrader": "Commodities Trader",
        "complianceRiskAnalyst": "Compliance/Risk Analyst",
        "consultant": "Consultant",
        "controller": "Controller",
        "creditAnalyst": "Credit Analyst",
        "creditManager": "Credit Manager",
        "customerServiceRepresentative": "Customer Service Representative",
        "economist": "Economist",
        "executiveSeniorManagementAccountingBankingInsuranceAndFinance": "Executive/Senior Management",
        "financialAnalyst": "Financial Analyst",
        "financialAdvisor": "Financial Advisor",
        "financialPlanner": "Financial Planner",
        "insuranceAgent": "Insurance Agent",
        "insuranceBroker": "Insurance Broker",
        "internalAuditor": "Internal Auditor",
        "investmentAnalyst": "Investment Analyst",
        "investmentBanker": "Investment Banker",
        "investmentConsultant": "Investment Consultant",
        "investmentFundManager": "Investment Fund Manager",
        "investmentRepresentative": "Investment Representative",
        "loanOfficer": "Loan Officer",
        "managementConsultant": "Management Consultant",
        "manager": "Manager",
        "mutualFundSalesRepresentative": "Mutual Fund Sales Representative",
        "portfolioManager": "Portfolio Manager",
        "productManager": "Product Manager",
        "securitiesTrader": "Securities Trader",
        "statistician": "Statistician",
        "stockBroker": "Stock Broker",
        "taxAssessmentAndCollectionsOfficer": "Tax Assessment and Collections Officer",
        "treasurer": "Treasurer",
        "underwriter": "Underwriter",
        "other": "Other"
      }
    },
    "administrationAndHumanResources": {
      "title": "Administration and Human Resources",
      "titles": {
        "administrativeAssistant": "Administrative Assistant",
        "clericalWorker": "Clerical Worker",
        "consultant": "Consultant",
        "customerServiceRepresentative": "Customer Service Representative",
        "custodian": "Custodian",
        "executiveAssistant": "Executive Assistant",
        "executiveSeniorManagementAdministrationAndHumanResources": "Executive/Senior Management",
        "facilitiesSpecialist": "Facilities Specialist",
        "generalOfficeClerk": "General Office Clerk",
        "humanResourcesConsultant": "Human Resources Consultant",
        "humanResourcesSpecialist": "Human Resources Specialist",
        "inventoryControlClerk": "Inventory Control Clerk",
        "inventoryControlSpecialist": "Inventory Control Specialist",
        "manager": "Manager",
        "mediator": "Mediator",
        "officeManager": "Office Manager",
        "personalAssistant": "Personal Assistant",
        "procurementOfficer": "Procurement Officer",
        "projectManager": "Project Manager",
        "purchasingAgent": "Purchasing Agent",
        "payrollBenefitsAdministrator": "Payroll/Benefits Administrator",
        "receptionist": "Receptionist",
        "recruiter": "Recruiter",
        "recordsManagementTechnician": "Records Management Technician",
        "telephoneOperator": "Telephone Operator",
        "unionRepresentative": "Union Representative",
        "other": "Other"
      }
    },
    "agricultureAndNaturalResources": {
      "title": "Agriculture and Natural Resources",
      "titles": {
        "agriculturalWorker": "Agricultural Worker",
        "agricultureAndNaturalResourcesSupportActivities": "Support Activities",
        "aquacultureWorker": "Aquaculture Worker",
        "breeder": "Breeder",
        "conservationist": "Conservationist",
        "customerServiceRepresentative": "Customer Service Representative",
        "dairyWorker": "Dairy Worker",
        "drillingOilAndGas": "Drilling - Oil and Gas",
        "executiveSeniorManagementAgricultureAndNaturalResources": "Executive/Senior Management",
        "farmer": "Farmer",
        "fisheriesWorker": "Fisheries Worker",
        "florist": "Florist",
        "foodProducer": "Food Producer",
        "forestryWorker": "Forestry Worker",
        "grainElevatorOperator": "Grain Elevator Operator",
        "harvester": "Harvester",
        "horticultureWorker": "Horticulture Worker",
        "inspector": "Inspector",
        "livestockWorker": "Livestock Worker",
        "loggingWorker": "Logging Worker",
        "managerAgricultureAndNaturalResources": "Manager, Agriculture and Natural Resources",
        "metalsProcessingWorker": "Metals Processing Worker",
        "meteorologist": "Meteorologist",
        "mineWorker": "Mine Worker",
        "nurseryGreenhouseWorker": "Nursery/Greenhouse Worker",
        "oilIndustryWorker": "Oil Industry Worker",
        "pulpAndPaperProcessingWorker": "Pulp and Paper Processing Worker",
        "quarryWorker": "Quarry Worker",
        "solarPowerWorker": "Solar Power Worker",
        "trapper": "Trapper",
        "undergroundWorker": "Underground Worker",
        "other": "Other"
      }
    },
    "artsEntertainmentAndCommunications": {
      "title": "Arts, Entertainment and Communications",
      "titles": {
        "actorActress": "Actor/Actress",
        "advertisingSpecialist": "Advertising Specialist",
        "animator": "Animator",
        "announcerBroadcaster": "Announcer/Broadcaster",
        "antiqueDealer": "Antique Dealer",
        "artisanCrafter": "Artisan/Crafter",
        "artist": "Artist",
        "audioVisualTechnician": "Audio-Visual Technician",
        "author": "Author",
        "casinoCustomerService": "Casino Customer Service",
        "casinoDealer": "Casino Dealer",
        "casinoGamingManager": "Casino Gaming Manager",
        "choreographer": "Choreographer",
        "communicationsSpecialist": "Communications Specialist",
        "composer": "Composer",
        "conductor": "Conductor",
        "curator": "Curator",
        "dancer": "Dancer",
        "designer": "Designer",
        "director": "Director",
        "editor": "Editor",
        "executiveSeniorManagementArtsEntertainmentAndCommunications": "Executive/Senior Management",
        "filmVideoCameraOperator": "Film/Video Camera Operator",
        "graphicArtist": "Graphic Artist",
        "graphicDesigner": "Graphic Designer",
        "illustrator": "Illustrator",
        "industrialDesigner": "Industrial Designer",
        "instructor": "Instructor",
        "interiorDesignerDecorator": "Interior Designer/Decorator",
        "interpreter": "Interpreter",
        "journalist": "Journalist",
        "makeupArtist": "Makeup Artist",
        "managerArtsEntertainmentAndCommunications": "Manager, Arts, Entertainment and Communications",
        "mediaRelations": "Media Relations",
        "model": "Model",
        "museumWorker": "Museum Worker",
        "musician": "Musician",
        "performingArtist": "Performing Artist",
        "photographer": "Photographer",
        "printer": "Printer",
        "producer": "Producer",
        "productionWorker": "Production Worker",
        "proofreader": "Proofreader",
        "publicRelationsWorker": "Public Relations Worker",
        "publicist": "Publicist",
        "publisher": "Publisher",
        "reporter": "Reporter",
        "researcher": "Researcher",
        "sculptor": "Sculptor",
        "singer": "Singer",
        "switchboardOperator": "Switchboard Operator",
        "tattooArtist": "Tattoo Artist",
        "theatreWorker": "Theatre Worker",
        "translator": "Translator",
        "writer": "Writer",
        "other": "Other"
      }
    },
    "educationAndTraining": {
      "title": "Education and Training",
      "titles": {
        "caretakerJanitor": "Caretaker/Janitor",
        "childCareWorker": "Child Care Worker",
        "counsellor": "Counsellor",
        "dean": "Dean",
        "earlyChildhoodEducator": "Early Childhood Educator",
        "educationAndTrainingSupportActivities": "Education and Training Support Activities",
        "educationalAssistant": "Educational Assistant",
        "employmentCounsellor": "Employment Counsellor",
        "executiveSeniorManagement": "Executive/Senior Management",
        "historian": "Historian",
        "instructor": "Instructor",
        "librarian": "Librarian",
        "lifeCoach": "Life Coach",
        "managerEducationAndTraining": "Manager, Education and Training",
        "officeAdminSecretary": "Office Admin/Secretary",
        "professor": "Professor",
        "researchAssistant": "Research Assistant",
        "researcher": "Researcher",
        "schoolBusDriver": "School Bus Driver",
        "schoolCounsellor": "School Counsellor",
        "schoolPrincipal": "School Principal",
        "schoolCollegeAdministrator": "School/College Administrator",
        "superintendent": "Superintendent",
        "teacher": "Teacher",
        "teachingAssistant": "Teaching Assistant",
        "trainer": "Trainer",
        "tutor": "Tutor",
        "vicePrincipal": "Vice Principal",
        "other": "Other"
      }
    },
    "engineeringArchitectureAndScience": {
      "title": "Engineering, Architecture and Science",
      "titles": {
        "aerospaceEngineer": "Aerospace Engineer",
        "architect": "Architect",
        "astronomer": "Astronomer",
        "biochemist": "Biochemist",
        "bioEngineer": "Bio-Engineer",
        "biologist": "Biologist",
        "cADDraftingTechnician": "CAD/Drafting Technician",
        "chemicalEngineer": "Chemical Engineer",
        "chemist": "Chemist",
        "civilEngineer": "Civil Engineer",
        "consultant": "Consultant",
        "electricalEngineer": "Electrical Engineer",
        "electricalPowerAndCableWorker": "Electrical Power and Cable Worker",
        "energyNuclearEngineer": "Energy/Nuclear Engineer",
        "executiveSeniorManagementEngineeringArchitectureAndScience": "Executive/Senior Management",
        "geochemist": "Geochemist",
        "geologist": "Geologist",
        "industrialEngineer": "Industrial Engineer",
        "inspector": "Inspector",
        "laboratoryTechnician": "Laboratory Technician",
        "managerEngineeringArchitectureAndScience": "Manager, Engineering, Architecture and Science",
        "manufacturingEngineer": "Manufacturing Engineer",
        "marineEngineer": "Marine Engineer",
        "mathematician": "Mathematician",
        "mechanicalEngineer": "Mechanical Engineer",
        "metallurgist": "Metallurgist",
        "meteorologist": "Meteorologist",
        "miningEngineer": "Mining Engineer",
        "nuclearPowerWorker": "Nuclear Power Worker",
        "petroleumEngineer": "Petroleum Engineer",
        "physicist": "Physicist",
        "powerSystemsEngineer": "Power Systems Engineer",
        "professionalEngineer": "Professional Engineer",
        "projectManager": "Project Manager",
        "researcher": "Researcher",
        "scientist": "Scientist",
        "sociologistAnthropologist": "Sociologist/Anthropologist",
        "urbanPlanner": "Urban Planner",
        "other": "Other"
      }
    },
    "governmentDiplomaticAndProtectiveServices": {
      "title": "Government, Diplomatic and Protective Services",
      "titles": {
        "ambassadorAttacheOrCounsellorOfAnAmbassador": "Ambassador, Attache or Counsellor of an Ambassador",
        "borderSecurityAgent": "Border Security Agent",
        "cityAdministrator": "City Administrator",
        "cityCounsellor": "City Counsellor",
        "civilServant": "Civil Servant",
        "communityServicesWorker": "Community Services Worker",
        "consultant": "Consultant",
        "correctionsOfficer": "Corrections Officer",
        "customsOfficer": "Customs Officer",
        "deputyMinister": "Deputy Minister",
        "diplomaticPersonnel": "Diplomatic Personnel",
        "emergencyMedicalTechnician": "Emergency Medical Technician",
        "firefighter": "Firefighter",
        "governmentAdministrator": "Government Administrator",
        "governmentInspector": "Government Inspector",
        "governmentServicesOfficer": "Government Services Officer",
        "governmentDiplomaticAndProtectiveServicesSupportActivities": "Support Activities",
        "headOfGovernmentAgencyInstituteOrCharity": "Head of Government Agency, Institute or Charity",
        "indigenousCouncilMember": "Indigenous Council Member",
        "intelligenceAnalysisSpecialist": "Intelligence/Analysis Specialist",
        "mayor": "Mayor",
        "memberOfGovernment": "Member of Government",
        "paramedic": "Paramedic",
        "policeOfficer": "Police Officer",
        "policyAnalyst": "Policy Analyst",
        "postalWorker": "Postal Worker",
        "programOfficer": "Program Officer",
        "regulatoryOfficer": "Regulatory Officer",
        "schoolBoardTrustee": "School Board Trustee",
        "securityGuard": "Security Guard",
        "socialWorker": "Social Worker",
        "urbanPlanner": "Urban Planner",
        "wasteRemoval": "Waste Removal",
        "other": "Other"
      }
    },
    "hospitalityFoodAndTourism": {
      "title": "Hospitality, Food and Tourism",
      "titles": {
        "baker": "Baker",
        "bartender": "Bartender",
        "butcher": "Butcher",
        "caterer": "Caterer",
        "chef": "Chef",
        "cook": "Cook",
        "customerServiceRepresentative": "Customer Service Representative",
        "eventsPlanner": "Events Planner",
        "executiveSeniorManagementHospitalityFoodAndTourism": "Executive/Senior Management",
        "ferryWorker": "Ferry Worker",
        "foodServicesWorker": "Food Services Worker",
        "hospitalityServicesWorker": "Hospitality Services Worker",
        "hostHostess": "Host/Hostess",
        "hotelStaff": "Hotel Staff",
        "housekeeper": "Housekeeper",
        "kitchenStaff": "Kitchen Staff",
        "manager": "Manager",
        "pastryChef": "Pastry Chef",
        "restaurantManager": "Restaurant Manager",
        "sousChef": "Sous Chef",
        "tourTravelGuide": "Tour/Travel Guide",
        "travelAgent": "Travel Agent",
        "waiterServer": "Waiter/Server",
        "other": "Other"
      }
    },
    "informationTechnology": {
      "title": "Information Technology",
      "titles": {
        "computerConsultant": "Computer Consultant",
        "computerEngineer": "Computer Engineer",
        "dataCentreManager": "Data Centre Manager",
        "dataEntryClerk": "Data Entry Clerk",
        "electronics": "Electronics",
        "executiveSeniorManagementInformationTechnology": "Executive/Senior Management",
        "informationSystems": "Information Systems",
        "projectManager": "Project Manager",
        "specialist": "Specialist",
        "multimediaProgrammer": "Multimedia Programmer",
        "productSpecialist": "Product Specialist",
        "softwareEngineer": "Software Engineer",
        "switchboardOperator": "Switchboard Operator",
        "technicalSupportAgent": "Technical Support Agent",
        "telecommunicationsInstaller": "Telecommunications Installer",
        "telecommunicationsSpecialist": "Telecommunications Specialist",
        "webDesigner": "Web Designer",
        "productManager": "Product Manager",
        "techExecutive": "Tech Executive",
        "uIUXDesigner": "UI/UX Designer",
        "other": "Other"
      }
    },
    "legalServices": {
      "title": "Legal Services",
      "titles": {
        "administrativeAssistant": "Administrative Assistant",
        "arbitrator": "Arbitrator",
        "articlingStudent": "Articling Student",
        "bailiff": "Bailiff",
        "byLawOfficer": "By-Law Officer",
        "courtOfficer": "Court Officer",
        "courtReporter": "Court Reporter",
        "judge": "Judge",
        "lawClerk": "Law Clerk",
        "lawyer": "Lawyer",
        "legalSupportActivities": "Legal Support Activities",
        "magistrateMaster": "Magistrate/Master",
        "notary": "Notary",
        "paralegal": "Paralegal",
        "paroleOfficer": "Parole Officer",
        "probationOfficer": "Probation Officer",
        "registrar": "Registrar",
        "other": "Other"
      }
    },
    "medicalHealthAndCareGiving": {
      "title": "Medical Health and Care Giving",
      "titles": {
        "acupuncturist": "Acupuncturist",
        "audiologist": "Audiologist",
        "cardiologist": "Cardiologist",
        "chiropractor": "Chiropractor",
        "counsellor": "Counsellor",
        "coroner": "Coroner",
        "dayCareWorker": "Day Care Worker",
        "dentalHygienist": "Dental Hygienist",
        "dentist": "Dentist",
        "dietitian": "Dietitian",
        "dispatcher": "Dispatcher",
        "doctor": "Doctor",
        "fosterParent": "Foster Parent",
        "funeralHomeWorker": "Funeral Home Worker",
        "healthCareCounsellor": "Health Care Counsellor",
        "homeCareWorker": "Home Care Worker",
        "homeopath": "Homeopath",
        "hospitalAdministrator": "Hospital Administrator",
        "inspector": "Inspector",
        "laboratoryTechnician": "Laboratory Technician",
        "massageTherapist": "Massage Therapist",
        "medicalTechnician": "Medical Technician",
        "midwife": "Midwife",
        "medicalImagingSpecialist": "Medical Imaging Specialist",
        "mortician": "Mortician",
        "nanny": "Nanny",
        "naturopath": "Naturopath",
        "nurse": "Nurse",
        "nutritionist": "Nutritionist",
        "occupationalTherapist": "Occupational Therapist",
        "ophthalmologist": "Ophthalmologist",
        "optician": "Optician",
        "optometrist": "Optometrist",
        "paramedic": "Paramedic",
        "pharmacyTechnician": "Pharmacy Technician",
        "pathologist": "Pathologist",
        "personalSupportWorker": "Personal Support Worker",
        "pharmacist": "Pharmacist",
        "physiotherapist": "Physiotherapist",
        "podiatrist": "Podiatrist",
        "psychologist": "Psychologist",
        "Radiologist": "Radiologist",
        "rehabilitationSpecialist": "Rehabilitation Specialist",
        "respiratoryTherapist": "Respiratory Therapist",
        "socialServicesWorker": "Social Services Worker",
        "speechPathologist": "Speech Pathologist",
        "surgeon": "Surgeon",
        "therapist": "Therapist",
        "veterinarian": "Veterinarian",
        "veterinarianTechnician": "Veterinarian Technician",
        "other": "Other"
      }
    },
    "militaryServices": {
      "title": "Military Services",
      "titles": {
        "administrativeOfficer": "Administrative Officer",
        "airTrafficController": "Air Traffic Controller",
        "aircraftTechnician": "Aircraft Technician",
        "artillerySpecialist": "Artillery Specialist",
        "chaplain": "Chaplain",
        "combatMedicCorpsman": "Combat Medic/Corpsman",
        "combatSoldierInfantry": "Combat Soldier/Infantry",
        "constructionCombatEngineer": "Construction/Combat Engineer",
        "cookFoodServices": "Cook/Food Services",
        "cyberWarfareSpecialist": "Cyber Warfare Specialist",
        "dentalTechnician": "Dental Technician",
        "electrician": "Electrician",
        "executiveSeniorManagement": "Executive/Senior Management",
        "explosiveOrdnanceDisposalEod": "Explosive Ordnance Disposal (EOD)",
        "financeSpecialist": "Finance Specialist",
        "firefighter": "Firefighter",
        "intelligenceAnalyst": "Intelligence Analyst",
        "judgeAdvocateJag": "Judge Advocate (JAG)",
        "logisticsAndSupplyOfficer": "Logistics and Supply Officer",
        "mechanic": "Mechanic",
        "mentalHealthSpecialist": "Mental Health Specialist",
        "militaryPilot": "Military Pilot",
        "militaryPoliceOfficer": "Military Police Officer",
        "navalOfficer": "Naval Officer",
        "nurse": "Nurse",
        "personnelSpecialist": "Personnel Specialist",
        "publicAffairsSpecialist": "Public Affairs Specialist",
        "quartermaster": "Quartermaster",
        "recruiter": "Recruiter",
        "securityForceProtection": "Security/Force Protection",
        "signalsCommunicationsSpecialist": "Signals/Communications Specialist",
        "specialOperations": "Special Operations",
        "submariner": "Submariner",
        "supportActivities": "Support Activities",
        "surgeon": "Surgeon",
        "trainingInstructor": "Training Instructor",
        "truckDriver": "Truck Driver",
        "welder": "Welder",
        "other": "Other"
      }
    },
    "realEstateAndRelated": {
      "title": "Real Estate and Related",
      "titles": {
        "appraiser": "Appraiser",
        "homeBuilder": "Home Builder",
        "homeInspector": "Home Inspector",
        "landDeveloper": "Land Developer",
        "landSurveyor": "Land Surveyor",
        "mortgageBroker": "Mortgage Broker",
        "propertyManager": "Property Manager",
        "propertyAssessor": "Property Assessor",
        "realEstateAgent": "Real Estate Agent",
        "renovator": "Renovator",
        "realEstateBroker": "Real Estate Broker",
        "realEstateAssessor": "Real Estate Assessor",
        "other": "Other"
      }
    },
    "religiousVocation": {
      "title": "Religious Vocation",
      "titles": {
        "chaplain": "Chaplain",
        "clergyman": "Clergyman",
        "deacon": "Deacon",
        "imam": "Imam",
        "minister": "Minister",
        "missionary": "Missionary",
        "monk": "Monk",
        "monsignor": "Monsignor",
        "nun": "Nun",
        "priest": "Priest",
        "rabbi": "Rabbi",
        "religiousWorker": "Religious Worker",
        "other": "Other"
      }
    },
    "salesRepairAndRetailService": {
      "title": "Sales, Repair and Retail Service",
      "titles": {
        "animalCareWorker": "Animal Care Worker",
        "animalTrainer": "Animal Trainer",
        "applianceRepairTechnician": "Appliance Repair Technician",
        "auctioneer": "Auctioneer",
        "automotiveRepair": "Automotive Repair",
        "automotiveSales": "Automotive Sales",
        "barber": "Barber",
        "buyer": "Buyer",
        "callCentreRepresentative": "Call Centre Representative",
        "cashier": "Cashier",
        "cleaningServiceProvider": "Cleaning Service Provider",
        "cosmetologist": "Cosmetologist",
        "customerServiceRepresentative": "Customer Service Representative",
        "dryCleaner": "Dry Cleaner",
        "electrologist": "Electrologist",
        "esthetician": "Esthetician",
        "executiveSeniorManagementSalesRepairAndRetailService": "Executive/Senior Management",
        "exterminatorPestControl": "Exterminator/Pest Control",
        "franchiseBusinessOwner": "Franchise - Business Owner",
        "hairdresser": "Hairdresser",
        "importerExporter": "Importer/Exporter",
        "installer": "Installer",
        "jeweler": "Jeweler",
        "managerSalesRepairAndRetailService": "Manager, Sales, Repair and Retail Service",
        "marketingRepresentative": "Marketing Representative",
        "merchandiser": "Merchandiser",
        "retailWorker": "Retail Worker",
        "salesAndRetailSupportWorker": "Sales and Retail Support Worker",
        "salesperson": "Salesperson",
        "seamstressTailor": "Seamstress/Tailor",
        "serviceStationAttendant": "Service Station Attendant",
        "shoeRepairMaker": "Shoe Repair/Maker",
        "smallEngineTechnician": "Small Engine Technician",
        "spaServiceProvider": "Spa Service Provider",
        "storeManager": "Store Manager",
        "telemarketer": "Telemarketer",
        "televisionTechnician": "Television Technician",
        "upholsterer": "Upholsterer",
        "visualDisplayMerchandisingSpecialist": "Visual Display/Merchandising Specialist",
        "windowWasher": "Window Washer",
        "other": "Other"
      }
    },
    "sportsAndLeisure": {
      "title": "Sports and Leisure",
      "titles": {
        "amusementParkWorker": "Amusement Park Worker",
        "coach": "Coach",
        "lifeguard": "Lifeguard",
        "personalServicesWorker": "Personal Services Worker",
        "personalTrainer": "Personal Trainer",
        "professionalAthlete": "Professional Athlete",
        "recreationalGuide": "Recreational Guide",
        "sportsAgent": "Sports Agent",
        "sportsInstructor": "Sports Instructor",
        "sportsManager": "Sports Manager",
        "sportsOfficial": "Sports Official",
        "sportsTherapist": "Sports Therapist",
        "other": "Other"
      }
    },
    "tradesConstructionAndManufacturing": {
      "title": "Trades, Construction and Manufacturing",
      "titles": {
        "apprentice": "Apprentice",
        "assemblyWorker": "Assembly Worker",
        "blacksmith": "Blacksmith",
        "boilermaker": "Boilermaker",
        "bricklayer": "Bricklayer",
        "builder": "Builder",
        "cabinetMaker": "Cabinet Maker",
        "carpenter": "Carpenter",
        "concreteWorker": "Concrete Worker",
        "constructionWorker": "Construction Worker",
        "craneOperator": "Crane Operator",
        "cutter": "Cutter",
        "developer": "Developer",
        "draftingDesign": "Drafting/Design",
        "driller": "Driller",
        "drywaller": "Drywaller",
        "electrician": "Electrician",
        "elevator Technician": "Elevator Technician",
        "engineer": "Engineer",
        "executiveSeniorManagementTradesConstructionAndManufacturing": "Executive/Senior Management",
        "fabricator": "Fabricator",
        "factoryWorker": "Factory Worker",
        "finisher": "Finisher",
        "forkliftOperator": "Forklift Operator",
        "foundryWorker": "Foundry Worker",
        "framer": "Framer",
        "gasFitter": "Gas Fitter",
        "generalContractor": "General Contractor",
        "glassFormerFinisher": "Glass Former/Finisher",
        "heavyDutyMechanic": "Heavy Duty Mechanic",
        "heavyEquipmentOperator": "Heavy Equipment Operator",
        "hVACInstaller": "HVAC Installer",
        "inspector": "Inspector",
        "installer": "Installer",
        "ironworker": "Ironworker",
        "labourer": "Labourer",
        "landscaper": "Landscaper",
        "locksmith": "Locksmith",
        "machineFitter": "Machine Fitter",
        "machineOperator": "Machine Operator",
        "manager": "Manager",
        "manufacturingWorker": "Manufacturing Worker",
        "mechanic": "Mechanic",
        "metalWorker": "Metal Worker",
        "millwright": "Millwright",
        "oilPipelineWorker": "Oil/Pipeline Worker",
        "painter": "Painter",
        "paver": "Paver",
        "pipefitter": "Pipefitter",
        "plasterer": "Plasterer",
        "plumber": "Plumber",
        "purchasingManager": "Purchasing Manager",
        "qualityAssuranceAnalyst": "Quality Assurance Analyst",
        "recycler": "Recycler",
        "renovator": "Renovator",
        "roofer": "Roofer",
        "sheetMetalWorker": "Sheet Metal Worker",
        "skilledLabourer": "Skilled Labourer",
        "steamfitter": "Steamfitter",
        "surveyor": "Surveyor",
        "textileWorker": "Textile Worker",
        "tileSetter": "Tile Setter",
        "toolAndDieMaker": "Tool and Die Maker",
        "tradesperson": "Tradesperson",
        "welder": "Welder",
        "weaver": "Weaver",
        "woodworker": "Woodworker",
        "other": "Other"
      }
    },
    "transportationAndUtilities": {
      "title": "Transportation and Utilities",
      "titles": {
        "airTrafficController": "Air Traffic Controller",
        "aircraftTechnician": "Aircraft Technician",
        "airlineAgent": "Airline Agent",
        "baggageHandler": "Baggage Handler",
        "busDriver": "Bus Driver",
        "cargoWorker": "Cargo Worker",
        "conductor": "Conductor",
        "courierDelivery": "Courier/Delivery",
        "customsInspection": "Customs Inspection",
        "deliveryDriver": "Delivery Driver",
        "dockWorker": "Dock Worker",
        "drillerBlaster": "Driller/Blaster",
        "executiveSeniorManagementTransportationAndUtilities": "Executive/Senior Management",
        "ferryWorker": "Ferry Worker",
        "flightAttendant": "Flight Attendant",
        "flightInstructor": "Flight Instructor",
        "heatingServiceProvider": "Heating Service Provider",
        "inspector": "Inspector",
        "janitor": "Janitor",
        "limoDriverChauffeur": "Limo Driver/Chauffeur",
        "logisticsAnalyst": "Logistics Analyst",
        "mover": "Mover",
        "oilHeating": "Oil Heating",
        "pilot": "Pilot",
        "publicWorksMaintenance": "Public Works Maintenance",
        "railwayMarineTransportWorker": "Railway/Marine Transport Worker",
        "shipmentBroker": "Shipment Broker",
        "shipperReceiver": "Shipper/Receiver",
        "taxiDriver": "Taxi/Driver",
        "transportationAndUtilitiesSupportActivities": "Transportation and Utilities Support Activities",
        "truckDriver": "Truck Driver",
        "utilityWorker": "Utility Worker",
        "wellDrillersOperators": "Well Drillers/Operators",
        "wellSiteSupervisor": "Well Site Supervisor",
        "waterTreatmentTechnician": "Water Treatment Technician",
        "other": "Other"
      }
    }
  },
  "areasOfStudy": {
    "aeronauticsAndAviationScience": "Aeronautics and Aviation Science",
    "anthropology": "Anthropology",
    "art": "Art",
    "businessAdministration": "Business Administration",
    "chemistry": "Chemistry",
    "economics": "Economics",
    "education": "Education",
    "engineering": "Engineering",
    "environmentalScienceAndHealth": "Environmental Science and Health",
    "journalismAndMassCommunication": "Journalism and Mass Communication",
    "music": "Music",
    "nursing": "Nursing",
    "oceanography": "Oceanography",
    "pharmacy": "Pharmacy",
    "photography": "Photography",
    "physicalTherapy": "Physical Therapy",
    "politicalScienceAndInternationalRelations": "Political Science and International Relations",
    "psychology": "Psychology",
    "publicRelationsAndAdministration": "Public Relations and Administration",
    "statistics": "Statistics",
    "urbanPlanning": "Urban Planning"
  },
  "previousCompanyType": "Previous {{companyType}}",
  "previousJobTitle": "Previous {{jobTitle}}",
  "previousEmployerName": "Previous {{employerName}}"
}
